import React, { useEffect, useState } from "react";

const DiscountCalculatorThree = ({ tasaDescuento, totalFinalTwo }) => {
  const mitad = tasaDescuento / 2;

  const [montos, setMontos] = useState({
    efectivo: 0,
    servicios: 0,
  });

  useEffect(() => {
    if (tasaDescuento) {
      const retiroEfectivo = (mitad * 0.30) / 13;
      const pagoServicios = (mitad * 0.15) / 4;



      setMontos({
        efectivo: retiroEfectivo.toFixed(2),
        servicios: pagoServicios.toFixed(2),
      });
    }
  }, [tasaDescuento]);

  const calcularBonificacion = (monto, porcentaje) => {
    return (parseFloat(monto) * porcentaje).toFixed(2);
  };

  const bonificacionTotal =
    parseFloat(calcularBonificacion(montos.efectivo, 13)) + parseFloat(calcularBonificacion(montos.servicios, 4)) + totalFinalTwo; // El totalFinaLTwo no sirve porque no esta llegando el prop

  const montoFinal = Math.abs(tasaDescuento - bonificacionTotal).toFixed(2);

  return (
    <>
      <h1 className="mx-auto text-center text-6xl pt-32 pb-24 text-[#EC0000] 2xl:text-5xl 2xl:max-w-5xl xs:text-3xl">
        Ingresa las transacciones y calcula la bonificación de cada una.
      </h1>
      <div className="bg-[#F0F0F0] p-6 rounded-lg mx-auto min-h-[550px] flex flex-col justify-center">
        <div className="grid grid-cols-4 md:grid-cols-1 items-center text-center h-full">
          <div className="p-6 text-[#EC0000] font-bold text-4xl leading-normal border-r border-[#EC0000] flex items-center justify-center h-full md:border-0">
            Calcula tu bonificación
          </div>
          <div className="p-6 border-r border-[#EC0000] flex flex-col justify-center md:border-0">
            <h3 className="text-[#EC0000] font-bold text-4xl border-b border-[#EC0000] pb-2 text-center">
              Servicios
            </h3>
            <p className="text-[#EC0000] mt-4 text-xl text-left ml-4">
              Retiro de Efectivo
            </p>
            <p className="text-[#EC0000] mt-4 text-xl text-left ml-4">
              Pago de Servicios
            </p>
          </div>

          <div className="p-6 border-r border-[#EC0000] flex flex-col justify-center md:border-0">
            <h3 className="text-[#EC0000] font-bold text-4xl border-b border-[#EC0000] pb-2 text-center">
              Transacciones
            </h3>
            <input
              type="text"
              className="block w-3/4 mx-auto mt-6 text-center border rounded-md p-2"
              value={parseFloat(montos.efectivo).toFixed(0)}
            />
            <input
              type="text"
              className="block w-3/4 mx-auto mt-6 text-center border rounded-md p-2"
              value={parseFloat(montos.servicios).toFixed(0)}
            />
          </div>

          <div className="p-6 flex flex-col justify-center">
            <h3 className="text-[#EC0000] font-bold text-4xl border-b border-[#EC0000] pb-2 text-center">
              Bonificación
            </h3>
            <p className="text-[#EC0000] text-center text-xl mt-6">
              ${parseFloat(calcularBonificacion(montos.efectivo, 13)).toFixed(0)}
            </p>
            <p className="text-[#EC0000] text-center text-xl mt-6">
              ${parseFloat(calcularBonificacion(montos.servicios, 4)).toFixed(0)}
            </p>

          </div>
        </div>
      </div>

      <div className="mt-10 text-[#EC0000] text-2xl font-bold flex flex-col items-start space-y-6 pl-72 md:pl-0">
        <div className="flex items-center space-x-36 pb-10 md:space-x-0">
          <p className="text-4xl pr-24 md:text-xl md:pr-10 md:pl-4">
            Te bonificaremos:
          </p>
          <div className="w-40 h-10 bg-[#EC0000] text-white flex justify-center items-center rounded-lg text-xl font-semibold">
            ${parseFloat(bonificacionTotal).toFixed(0)}
          </div>
        </div>

        <div className="flex items-center space-x-6 md:space-x-0 md:pr-12 xs:pr-10">
          <p className="text-4xl pr-24 md:text-xl md:pl-4 xs:pr-0">
            ¡Felicidades! Sólo pagarás
          </p>
          <div className="w-40 h-10 bg-[#F0F0F0] flex justify-center items-center rounded-lg border border-[#EC0000] text-xl font-semibold">
            ${parseFloat(montoFinal).toFixed(0)}
          </div>
        </div>
      </div>
    </>
  );
};

export default DiscountCalculatorThree;
